<template>
  <div class="plan-dialog">
    <van-popup v-model="planPopup" position="bottom" :round="true" :style="{ 'max-height': '566px', 'min-height': '266px' }" get-container="#app">
      <div class="plan-popup-content">
        <div class="popup-title">{{ currentPlanInfo.id ? $t('button.edit') : $t('button.create') }} {{ $t('shared.visitPlan') }}</div>
        <div class="plan-form-content">
          <div class="form-item">
            <div class="label required">
              <span>{{ $t('form.planName') }}</span>
            </div>
            <van-field v-model="planForm.planName" placeholder="" :border="false" maxlength="100" />
          </div>
          <div class="form-item">
            <div class="label required">
              <span>{{ $t('form.plannedVisitDate') }}</span>
            </div>
            <van-field :value="planForm.planTime" readonly :placeholder="$t('shared.filter.selectDate')" @click="showDatePicker = true" :border="false" />
            <van-popup v-model="showDatePicker" position="bottom">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                :title="$t('shared.filter.selectDate')"
                :min-date="minDate"
                @confirm="onDateConfirm"
                @cancel="showDatePicker = false"
              />
            </van-popup>
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.addToSchedule') }}</span>
            </div>
            <van-field>
              <template #input>
                <van-switch v-model="planForm.isAddSchedule" size="20" inactive-color="#eaeaec" />
              </template>
            </van-field>
          </div>
          <div class="plan-tips">{{ $t('tips.messageFiftyTwo') }}</div>
        </div>
        <div class="operate-btn">
          <van-button type="primary" @click="planPopup = false">{{ $t('button.cancel') }}</van-button>
          <van-button class="confirm-btn" type="primary" @click="handleOper">{{ $t('button.confirm') }}</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment'
import { Toast, Notify } from 'vant'
import { visitPlanAddApi } from '@/api/visitPlan'
export default {
  props: {
    currentPlanInfo: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      planPopup: false,
      currentDate: new Date(),
      minDate: new Date(),
      showDatePicker: false,
      planForm: {
        id: '',
        planName: '',
        planTime: '',
        isAddSchedule: false
      }
    }
  },
  watch: {
    planPopup (newVal) {
      if (newVal) {
        Object.keys(this.planForm).forEach(subItem => {
          if (subItem === 'isAddSchedule') {
            this.planForm[subItem] = this.currentPlanInfo[subItem] || false
          } else {
            this.planForm[subItem] = this.currentPlanInfo[subItem] || ''
          }
        })
      }
    }
  },
  methods: {
    onDateConfirm (time) {
      this.planForm.planTime = moment(time).format('YYYY-MM-DD')
      this.showDatePicker = false
    },
    handleOper () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      const data = {
        ...this.planForm,
        targetId: '',
        targetType: ''
      }
      visitPlanAddApi(data).then(res => {
        Toast.clear()
        this.planPopup = false
        Notify({ type: 'success', message: this.$t('shared.success'), duration: 1500 })
        this.$emit('operSuccess')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.plan-popup-content {
  padding: 10px 18px 20px 18px;
  .popup-title {
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    margin-bottom: 10px;
  }
  .plan-form-content {
    max-height: 436px;
    min-height: 266px;
    margin-top: 10px;
    overflow: auto;
    .form-item {
      display: flex;
      align-items: center;
      margin-bottom: 13px;
      border-bottom: 1px solid #ebedf0;
      .label {
        width: 100px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #333;
        margin-bottom: 8px;
        // 添加必填标记样式
        &.required {
          position: relative;
          padding-left: 12px; // 为星号预留空间
          &::before {
            content: '*';
            color: #ff4444;
            position: absolute;
            left: 0;
            top: 0;
            font-size: 14px;
            line-height: 1;
          }
        }
      }
    }
    .plan-tips {
      font-size: 11px;
      color: #b5b2b2;
    }
  }
  .operate-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    justify-content: space-between;
    /deep/.van-button {
      width: 126px;
      height: 40px;
      background-color: #dce5f6;
      border: 1px solid #dce5f6;
      border-radius: 8px;
      color: #000;
    }
    .confirm-btn {
      width: 190px;
      color: #fff;
      background-color: #307bff;
      border: 1px solid #307bff;
    }
  }
}
</style>
